// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFieldStateType } from './IFieldStateType';
import {
    IFieldStateTypeFromJSON,
    IFieldStateTypeFromJSONTyped,
    IFieldStateTypeToJSON,
    IFieldStateTypeToJSONTyped,
} from './IFieldStateType';

/**
 * 
 * @export
 * @interface ICommunicationChannelsInfoDto
 */
export interface ICommunicationChannelsInfoDto {
    /**
     * 
     * @type {Set<string>}
     * @memberof ICommunicationChannelsInfoDto
     */
    communication_channel_types: Set<ICommunicationChannelsInfoDtoCommunicationChannelTypesEnum>;
    /**
     * 
     * @type {IFieldStateType}
     * @memberof ICommunicationChannelsInfoDto
     */
    communication_channel_types_state?: IFieldStateType;
}

/**
* @export
* @enum {string}
*/
export enum ICommunicationChannelsInfoDtoCommunicationChannelTypesEnum {
    NOTIFICATION_CENTER = 'NOTIFICATION_CENTER',
    EMAIL_SMS = 'EMAIL_SMS',
    DATA_EXPORT = 'DATA_EXPORT'
}


/**
 * Check if a given object implements the ICommunicationChannelsInfoDto interface.
 */
export function instanceOfICommunicationChannelsInfoDto(value: object): value is ICommunicationChannelsInfoDto {
    if (!('communication_channel_types' in value) || value['communication_channel_types'] === undefined) return false;
    return true;
}

export function ICommunicationChannelsInfoDtoFromJSON(json: any): ICommunicationChannelsInfoDto {
    return ICommunicationChannelsInfoDtoFromJSONTyped(json, false);
}

export function ICommunicationChannelsInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICommunicationChannelsInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'communication_channel_types': new Set(json['communication_channel_types']),
        'communication_channel_types_state': json['communication_channel_types_state'] == null ? undefined : IFieldStateTypeFromJSON(json['communication_channel_types_state']),
    };
}

export function ICommunicationChannelsInfoDtoToJSON(json: any): ICommunicationChannelsInfoDto {
    return ICommunicationChannelsInfoDtoToJSONTyped(json, false);
}

export function ICommunicationChannelsInfoDtoToJSONTyped(value?: ICommunicationChannelsInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'communication_channel_types': Array.from(value['communication_channel_types'] as Set<any>),
        'communication_channel_types_state': IFieldStateTypeToJSON(value['communication_channel_types_state']),
    };
}

